module.exports = __webpack_public_path__ + "static/media/arrow_left_icon.5681b6c1.svg";